module.exports = __webpack_public_path__ + "0af5d249/img/grid-web-icon.d0395d64.svg";